module.exports = __webpack_public_path__ + "static/media/heartbeat-3.c309a6b0.png";